// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__lS9wW","search":"Settings_search__1lvJ_","filter":"Settings_filter__2OoJW"};